import { render, staticRenderFns } from "./updateLog.vue?vue&type=template&id=7a31ecf0"
import script from "./updateLog.vue?vue&type=script&lang=js"
export * from "./updateLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports